// src/components/ui/cta/ClientCtaForm.tsx

"use client"

import { useEffect, useRef } from "react"
import { useScrollContext } from "~/components/ScrollContext"
import { ToastProvider } from "~/components/Toast"
import { Toaster } from "~/components/Toaster"
import EmailForm from "~/components/email-form"

export function ClientCtaForm(): JSX.Element {
  const ref = useRef<HTMLDivElement>(null)
  const { registerRef } = useScrollContext()

  useEffect(() => {
    registerRef("email-form", ref)
  }, [registerRef])

  return (
    <ToastProvider>
      <div
        ref={ref}
        className="mt-14 w-full rounded-[16px] bg-gray-300/5 p-1.5 ring-1 ring-black/[3%] backdrop-blur dark:bg-gray-900/10 dark:ring-white/[3%]">
        <div className="rounded-xl bg-white p-4 shadow-lg shadow-indigo-500/10 ring-1 ring-black/5 dark:bg-gray-950 dark:shadow-indigo-500/10 dark:ring-white/5">
          <EmailForm />
        </div>
      </div>
      <Toaster />
    </ToastProvider>
  )
}